(function () {
  const railSelector = '.product--thumbnail.product--carousel-position-left [id^="GalleryThumbnails"]';

  function getStep(slider, direction) {
    const items = Array.from(slider.querySelectorAll('.thumbnail-list__item')).filter((item) => item.offsetHeight > 0);
    if (items.length < 2) return slider.clientHeight;

    const first = items[0];
    const second = items[1];
    const itemGap = Math.max(0, second.offsetTop - first.offsetTop - first.offsetHeight);
    const button = direction === 'next'
      ? slider.closest('slider-component')?.querySelector('[name="next"]')
      : slider.closest('slider-component')?.querySelector('[name="previous"]');
    const count = Number(button?.dataset.step) || 1;

    return (first.offsetHeight + itemGap) * count;
  }

  function updateButtons(component) {
    const slider = component.querySelector('[id^="Slider-Thumbnails"]');
    const prevButton = component.querySelector('[name="previous"]');
    const nextButton = component.querySelector('[name="next"]');
    if (!slider || !prevButton || !nextButton) return;

    const maxScroll = Math.max(0, slider.scrollHeight - slider.clientHeight);
    const hasOverflow = maxScroll > 1;

    prevButton.toggleAttribute('disabled', !hasOverflow || slider.scrollTop <= 1);
    nextButton.toggleAttribute('disabled', !hasOverflow || slider.scrollTop >= maxScroll - 1);
  }

  function setUpRail(component) {
    if (!component || component.dataset.thumbnailRailReady === 'true') return;

    const slider = component.querySelector('[id^="Slider-Thumbnails"]');
    if (!slider) return;

    component.dataset.thumbnailRailReady = 'true';
    component.classList.add('thumbnail-slider--vertical');

    component.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('.slider-button');
        if (!button || !component.contains(button)) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const direction = button.name === 'previous' ? 'previous' : 'next';
        const maxScroll = Math.max(0, slider.scrollHeight - slider.clientHeight);
        const nextTop =
          direction === 'next'
            ? Math.min(slider.scrollTop + getStep(slider, direction), maxScroll)
            : Math.max(slider.scrollTop - getStep(slider, direction), 0);

        slider.scrollTo({ top: nextTop, behavior: 'smooth' });
      },
      true
    );

    slider.addEventListener('scroll', () => updateButtons(component), { passive: true });
    window.addEventListener('resize', () => updateButtons(component));
    updateButtons(component);
  }

  function setUpAllRails(container = document) {
    container.querySelectorAll(railSelector).forEach(setUpRail);
  }

  document.addEventListener('DOMContentLoaded', () => setUpAllRails());
  document.addEventListener('shopify:section:load', (event) => setUpAllRails(event.target));
})();
